import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { FindRetailerAdvert as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/adverts/find_retailer_advert.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null on
 * the standalone template path) and is ignored.
 */
export const FindRetailerAdvert = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section className="blocks blocks--x1 ptb container">
            <div className="lead-in">
                <h3 className="lead-in__headline">{t`Shop Online`}</h3>
                <p className="lead-in__copy">
                    {t`Sealy mattresses are available through our retailer's websites. Or, you can shop for a Cocoon™ by Sealy, our bed-in-a-box that's available exclusively online.`}
                </p>
            </div>

            <div className="blocks__block">
                <figure className="blocks__image">
                    <img
                        className="img-responsive"
                        src={`${staticURL}img/advert/blocks-cocoon.jpg`}
                        alt={t`Cocoon by Sealy Image`}
                        loading="lazy"
                        decoding="async"
                    />
                </figure>
                <div className="blocks__content">
                    <h4 className="blocks__headline">{t`Cocoon™ by Sealy`}</h4>
                    <h5 className="blocks__subtext">
                        {t`Free Delivery · Hassle Free Returns · 10 Year Warranty`}
                    </h5>
                    <p className="blocks__descript">
                        {t`Get a premium memory foam mattress in a box, shipping right to your door. Only available online! Starting at $399.`}
                    </p>
                    {/* rel="noreferrer" is a deliberate (visually inert) addition
                        over the legacy markup: eslint react/jsx-no-target-blank
                        requires it on target="_blank" links. */}
                    <a
                        className="blocks__cta button"
                        href="http://www.cocoonbysealy.com"
                        target="_blank"
                        rel="noreferrer"
                        title={t`Shop at Cocoon by Sealy`}
                    >
                        {t`Shop at CocoonbySealy.com`}
                    </a>
                </div>
            </div>
        </section>
    );
};
